<!-- 场景应用 -->
<template>
  <div class="applicationScenarios">
    <el-row :gutter="25">
      <el-col :span="8">
        <div class="grid-content bg-purple left-map">
          <leaflet-map></leaflet-map>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content bg-purple content forecast">
          <div class="weather-forecast">
            <div class="yltitle">
              <span class="titleicon"></span>
              <span class="indextitle">天气预报</span>
              <span class="titleline"></span>
              <now-time></now-time>
            </div>
          </div>
          <el-row :gutter="5" style="margin-top:0">
            <el-col :span="8">
              <div class="grid-content bg-purple content weather-forecast-content"></div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple content weather-forecast-content"></div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple content weather-forecast-content"></div>
            </el-col>
          </el-row>
        </div>
        <div class="grid-content bg-purple content">
          <div class="over30rainfall">
            <div class="yltitle">
              <span class="titleicon"></span>
              <span class="indextitle">1h超30mm雨量站</span>
              <span class="titleline"></span>
              <span class="title-right"
                >超警<b style="color:#ff6701"> {{ oneHourDataNum }} </b>个</span
              >
            </div>
            <el-table :data="oneHourData" :show-header="false" height="230" stripe style="width: 100%">
              <el-table-column label="stnm" width="450">
                <template slot-scope="scope" style="text-align:center"><span class="icon"></span>{{ scope.row.stnm }}</template>
              </el-table-column>
              <el-table-column label="rainValue">
                <template slot-scope="scope" style="text-align:center">雨量：{{ scope.row.rainValue }}mm</template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="grid-content bg-purple content">
          <div class="over50rainfall">
            <div class="yltitle">
              <span class="titleicon"></span>
              <span class="indextitle">3h超50mm雨量站</span>
              <span class="titleline"></span>
              <span class="title-right"
                >超警<b style="color:#ff6701"> {{ threeHourDataNum }} </b>个</span
              >
            </div>
            <el-table :data="threeHourData" :show-header="false" height="235" stripe style="width: 100%">
              <el-table-column label="名称" width="450">
                <template slot-scope="scope" style="text-align:center"><span class="icon"></span>{{ scope.row.stnm }}</template>
              </el-table-column>
              <el-table-column label="雨量">
                <template slot-scope="scope" style="text-align:center">雨量：{{ scope.row.rainValue }}mm</template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content bg-purple content">
          <div class="overwarn-waterlevel">
            <div class="yltitle">
              <span class="titleicon"></span>
              <span class="indextitle">超警水位站</span>
              <span class="titleline"></span>
              <span class="title-right"
                >超警<b style="color:#ff6701"> {{ overWarnDataNum }} </b>个</span
              >
            </div>
            <el-table :data="overWarnData" :show-header="false" height="230" stripe style="width: 100%">
              <el-table-column label="stnm" width="450">
                <template slot-scope="scope" style="text-align:center"><span class="icon"></span>{{ scope.row.stnm }}</template>
              </el-table-column>
              <el-table-column label="水位">
                <template slot-scope="scope" style="text-align:center">水位：{{ scope.row.z }}m</template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="grid-content bg-purple content">
          <div class="warning-village">
            <div class="yltitle">
              <span class="titleicon"></span>
              <span class="indextitle">预警村落</span>
              <span class="titleline"></span>
              <span class="title-right"
                >超警<b style="color:#ff6701"> {{ warnDataNum }} </b>个</span
              >
            </div>
            <el-table :data="warnData" :show-header="false" height="230" stripe style="width: 100%">
              <el-table-column label="名称" width="400">
                <template slot-scope="scope" style="text-align:center"><span class="icon"></span>{{ scope.row.name }}</template>
              </el-table-column>
              <el-table-column label="预警时间">
                <template slot-scope="scope" style="text-align:center">预警时间：{{ scope.row.warntime }}</template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="grid-content bg-purple content gate">
          <div class="open-gate" style="margin-top:-25px">
            <el-row class="gate-content">
              <div class="yltitle">
                <span class="titleicon"></span>
                <span class="indextitle">闸门开度</span>
                <span class="titleline"></span>
                <span class="xiangqing">更多</span>
                <span class="more"></span>
              </div>
              <div class="zmcontent" :class="{ zmcontent_active: index == choosed }" v-for="(item, index) in gateData" :key="index" @click="checkItem(item, index)">
                <div class="zmtitle" :class="{ zmtitle_active: index == choosed }">
                  <span>{{ item.name }}</span>
                </div>
                <div class="zmleft">
                  <div class="zksnum">
                    <span>{{ item.gateNum }}</span>
                  </div>
                  <div class="zks">
                    <span>闸孔数</span>
                  </div>
                </div>
                <div class="zmline"></div>
                <div class="zmlright">
                  <div class="kksnum">
                    <span>{{ item.openGateNum }}</span>
                  </div>
                  <div class="kks">
                    <span>开孔数</span>
                  </div>
                </div>
              </div>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import centerMap from './newMap'
import nowtime from '../nowtime'
import applicationScenariosTypes from '@/store/types/applicationScenarios'
import homepageTypes from '@/store/types/homepage'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    'leaflet-map': centerMap,
    'now-time': nowtime
  },
  data() {
    // 这里存放数据
    return {
      choosed: 0,
      sortType: '',
      sID: '22',
      sTID: '',
      stationType: '1',
      oneHourData1: [
        {
          name: '曹娥江闸雨量',
          rainfall: '38.0'
        },
        {
          name: '边头坞水库',
          rainfall: '40.0'
        },
        {
          name: '滨海闸',
          rainfall: '38.5'
        },
        {
          name: '安昌雨量',
          rainfall: '44.5'
        },
        {
          name: '大岙水库',
          rainfall: '35.0'
        }
      ],
      threeHourData1: [
        {
          name: '边头坞水库',
          rainfall: '64.0'
        },
        {
          name: '安昌雨量',
          rainfall: '84.5'
        },
        {
          name: '大岙水库',
          rainfall: '54.0'
        },
        {
          name: '大鸡笼水库',
          rainfall: '52.5'
        },
        {
          name: '滨海闸',
          rainfall: '58.5'
        },
        {
          name: '大坑水库',
          rainfall: '52.0'
        },
        {
          name: '曹娥江闸雨量',
          rainfall: '55.0'
        }
      ],
      oneHourData: [],
      threeHourData: [],
      overWarnData1: [
        {
          name: '若耶溪水位站',
          waterlevel: '4.52'
        },
        {
          name: '杨汛桥',
          waterlevel: '4.41'
        },
        {
          name: '鉴湖',
          waterlevel: '4.08'
        },
        {
          name: '楝树下闸上游',
          waterlevel: '4.07'
        },
        {
          name: '马山闸闸上',
          waterlevel: '4.07'
        }
      ],
      overWarnData: [],
      warnData: [
        {
          name: '平水镇-新横溪村-新庄村',
          warntime: '2019-5-31 17:15'
        },
        {
          name: '湖塘街道-永新村-丰里村',
          warntime: '2019-5-31 17:15'
        },
        {
          name: '稽东镇-大桥村-上冯村',
          warntime: '2019-5-31 17:15'
        },
        {
          name: '湖塘街道-永新村-丰里村',
          warntime: '2019-5-31 17:15'
        }
      ],
      gateData: [
        {
          name: '萧山枢纽',
          gateNum: '2',
          openGateNum: '2'
        },
        {
          name: '新三江闸',
          gateNum: '15',
          openGateNum: '1'
        },
        {
          name: '马山闸',
          gateNum: '62',
          openGateNum: '2'
        },
        {
          name: '曹娥江大闸',
          gateNum: '28',
          openGateNum: '0'
        },
        {
          name: '三兴闸',
          gateNum: '3',
          openGateNum: '2'
        },
        {
          name: '浦前闸',
          gateNum: '7',
          openGateNum: '3'
        },
        {
          name: '闸头堰闸',
          gateNum: '1',
          openGateNum: '1'
        },
        {
          name: '牟山闸',
          gateNum: '2',
          openGateNum: '1'
        },
        {
          name: '七塘闸',
          gateNum: '5',
          openGateNum: '3'
        }
      ],
      oneHourDataNum: '',
      threeHourDataNum: '',
      overWarnDataNum: '',
      warnDataNum: '12'
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 获取1h超30mm雨量站
    getOneHourOver30mm() {
      this.$store
        .dispatch(applicationScenariosTypes.GET_OVERFLOW30MM_RAINBEFORE1HOUR, {
          sID: this.sID
        })
        .then((data) => {
          this.oneHourData = data.rows
          // console.log(data.rows)
          this.oneHourDataNum = this.oneHourData.length
          // 1h超30mm雨量站排序
          this.dataSort('rainValue', this.oneHourData)
        })
    },
    // 获取3h超50mm雨量站
    getThreeHourOver50mm() {
      this.$store
        .dispatch(applicationScenariosTypes.GET_OVERFLOW50MM_RAINBEFORE3HOUR, {
          sID: this.sID
        })
        .then((data) => {
          this.threeHourData = data.rows
          // console.log(data.rows)
          this.threeHourDataNum = this.threeHourData.length
          // 3h超30mm雨量站排序
          this.dataSort('rainValue', this.threeHourData)
        })
    },
    // 获取超警水位站数据
    getWaterLevelData() {
      this.$store
        .dispatch(homepageTypes.GET_LATEST_WATER_LEVEL, {
          sID: this.sID,
          sTID: this.sTID,
          stationType: this.stationType
        })
        .then((data) => {
          var tempData = data.rows
          for (let i in tempData) {
            if (tempData[i].diff > 0) {
              this.overWarnData.push(tempData[i])
            }
          }
          this.overWarnDataNum = this.overWarnData.length
          // 超警水位站排序
          this.dataSort('z', this.overWarnData)
        })
    },
    // 数据排序
    dataSort(type, sortData) {
      this.sortType = type
      sortData.sort(this.compare(type))
    },
    compare(attr) {
      return function(a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val2 - val1
      }
    },
    // 选择对应地点闸门开度
    checkItem(item, index) {
      this.choosed = index
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // 获取1h超30mm雨量站
    this.getOneHourOver30mm()
    // 获取3h超50mm雨量站
    this.getThreeHourOver50mm()
    // 获取超警水位
    this.getWaterLevelData()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.el-row {
  margin-top: 25px;
  width: 100%;
}
.left-map {
  width: 600px;
  height: 845px;
  margin-left: 20px;
  float: left;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content {
  width: 100%;
  height: 275px;
  background: #fff;
}
.yltitle {
  width: 100%;
  float: left;
  padding-top: 10px;
  padding-bottom: 10px;
}
.titleicon {
  width: 50px;
  height: 10px;
  background-image: url(../../assets/homepage_img/indextitle.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: block;
  float: left;
  margin-top: 6px;
  margin-left: 15px;
}
.indextitle {
  font-family: Microsoft YaHei UI;
  font-size: 18px;
  color: #515766;
  display: block;
  float: left;
  margin-left: 10px;
}
.titleline {
  border-bottom: 1px solid #d6dbea;
  display: block;
  width: 260px;
  float: left;
  margin-top: 12px;
  margin-left: 15px;
}
.title-right {
  float: right;
  margin-right: 25px;
}
.forecast,
.gate {
  height: 295px;
}

/* 表格通用 */
.el-table__body .el-table__row .icon {
  width: 60px;
  height: 20px;
  display: block;
  float: left;
}
/* 天气预报 */
.weather-forecast-content {
  width: 80%;
  height: 220px;
  margin: 0 auto;
}
.forecast .el-col-8:nth-child(1) .weather-forecast-content {
  background: url(../../assets/applicationScenarion_img/today.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.forecast .el-col-8:nth-child(2) .weather-forecast-content {
  background: url(../../assets/applicationScenarion_img/tomorrow.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.forecast .el-col-8:nth-child(3) .weather-forecast-content {
  background: url(../../assets/applicationScenarion_img/afterTomorrow.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
/* 1h超30mm雨量站 3h超50mm雨量站 超警水位站 图标 */
.over30rainfall .el-table__body .el-table__row:nth-child(1) .icon,
.over50rainfall .el-table__body .el-table__row:nth-child(1) .icon,
.overwarn-waterlevel .el-table__body .el-table__row:nth-child(1) .icon {
  background: url(../../assets/applicationScenarion_img/top.png);
  background-repeat: no-repeat;
  background-position: 15px 6px;
}
.over30rainfall .el-table__body .el-table__row:nth-child(2) .icon,
.over50rainfall .el-table__body .el-table__row:nth-child(2) .icon,
.overwarn-waterlevel .el-table__body .el-table__row:nth-child(2) .icon {
  background: url(../../assets/applicationScenarion_img/top.png);
  background-repeat: no-repeat;
  background-position: 15px -37px;
}
.over30rainfall .el-table__body .el-table__row:nth-child(3) .icon,
.over50rainfall .el-table__body .el-table__row:nth-child(3) .icon,
.overwarn-waterlevel .el-table__body .el-table__row:nth-child(3) .icon {
  background: url(../../assets/applicationScenarion_img/top.png);
  background-repeat: no-repeat;
  background-position: 15px -74px;
}
.over30rainfall .el-table__body .el-table__row:nth-child(4) .icon,
.over50rainfall .el-table__body .el-table__row:nth-child(4) .icon,
.overwarn-waterlevel .el-table__body .el-table__row:nth-child(4) .icon {
  background: url(../../assets/applicationScenarion_img/top.png);
  background-repeat: no-repeat;
  background-position: 15px -114px;
}
.over30rainfall .el-table__body .el-table__row:nth-child(5) .icon,
.over50rainfall .el-table__body .el-table__row:nth-child(5) .icon,
.overwarn-waterlevel .el-table__body .el-table__row:nth-child(5) .icon {
  background: url(../../assets/applicationScenarion_img/top.png);
  background-repeat: no-repeat;
  background-position: 15px -155px;
}
/* 预警村落 */
.warning-village .el-table__body .el-table__row .icon {
  background: url(../../assets/applicationScenarion_img/point.png);
  background-repeat: no-repeat;
  background-position: center center;
}
/* 闸门开度 */
.open-gate .titleline {
  width: 375px;
}
.xiangqing {
  display: block;
  float: left;
  font-family: Microsoft YaHei UI;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  margin-top: 3px;
  margin-left: 10px;
}
.more {
  display: block;
  float: left;
  background-image: url(../../assets/homepage_img/more.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 11px;
  height: 11px;
  margin-top: 6px;
  margin-left: 15px;
  cursor: pointer;
}
.zmcontent {
  width: 28%;
  height: 75px;
  float: left;
  border: 1px solid #f0f3f8;
  margin-left: 22px;
  margin-top: 5px;
}
.zmcontent_active {
  color: #ffffff;
  border: 1px solid #3e76fb;
}
.zmtitle {
  font-family: Microsoft YaHei UI;
  font-size: 14px;
  color: #343532;
  text-align: center;
  width: 100%;
  height: 29px;
  background-color: #f0f3f8;
  padding-top: 6px;
}
.zmtitle_active {
  color: #ffffff;
  background-color: #3d76fa;
}
.zmleft {
  width: 74px;
  height: 60px;
  float: left;
}
.zksnum,
.kksnum {
  margin-top: 6px;
  font-family: Microsoft YaHei UI;
  font-size: 14px;
  text-align: center;
  width: 100%;
}
.zksnum {
  color: #676767;
}
.kksnum {
  color: #406efb;
}
.zks,
.kks {
  margin-top: 6px;
  font-family: Microsoft YaHei UI;
  font-size: 12px;
  color: #a3a3a3;
  text-align: center;
  width: 100%;
}
.zmline {
  border-left: 2px solid #f0f3f8;
  float: left;
  height: 35px;
  margin-top: 5px;
}
</style>
